/* global angular, _ */

var ngModule = angular.module('trends');

ngModule.service('TagManager', ['$location', '$document', '$state', '$rootScope', '$window',
    function ($location, $document, $state, $rootScope, $window) {
        var service = this;

        this.active = function () {
            return !!$window.dataLayer;
        };

        this.push = function (values) {
            if ($window.dataLayer) {
                $window.dataLayer.push(values);
            }
        };

        this.pageView = function (path, title) {
            service.push({
                'event': 'virtualPageView',
                'virtualPagePath': path || $location.url(),
                'virtualPageTitle': title || $document[0].title
            });
        };

        this.event = function (event, details) {
            service.push(angular.extend(
                details || {},
                { 'event': event }
            ));
        };

        var updatePageId = function () {
            var current = $state.current;
            var pageId = current.name;
            service.value = null;

            if (current.pageIdFn) {
                pageId = current.pageIdFn($state.params, current);
            } else {
                var paramValues = _.values($state.params);
                if (paramValues.length === 1) {
                    pageId = current.name + '-' + paramValues[0];
                    service.value = paramValues[0];
                }
            }

            service.push({'page-id': pageId + ' - ' + $document[0].title});
        };
        updatePageId();

        var updatePagePath = function () {
            service.push({'page-path': $location.path()});
        };
        updatePagePath();

        $rootScope.$on('$stateChangeSuccess', function () {
            updatePageId();
            updatePagePath();
        });
        $rootScope.$watch(function () {
            return $document[0].title;
        }, updatePageId);
    }
]);
